<template>
   <div>
       <div class="container ">

           <div class="tax-information  ">
               <div class="tax-head">
                   <h1>Tax Information</h1>
               </div>

               <div class="navbar-holder">

                   <ul class="inner-navbar">
                       <li>
                           <div class="form-group ">
                               <label >Choose Tax Slab</label>
                               <div class="nav-selectdrop">
                                   <select id="inputState" class="form-control text-capitalize" v-model="selectSlab" @change="changeSlabFunction($event)">
                                       <option class="text-capitalize" v-for="slabInfo in taxSlabInfo" :value="slabInfo.id" :key="slabInfo.id">{{slabInfo.name}}</option>

                                   </select>
                               </div>
                           </div>
                       </li>
                       <!--<li><a href="#" class="btn btn-primary btn-sm"   @click="editSlabInfo" >Edit slab</a></li>-->
                       <li><a href="#" class="btn btn-primary btn-sm"  data-toggle="modal" data-target=".bd-example-modal-lg">Create Slab</a></li>
                   </ul>

                   <!--<ul class="inner-navbar float-right">
                       <li><a href="#" class="btn btn-primary btn-sm"  data-toggle="modal" data-target=".bd-example-modal-lg">Add New Slab</a></li>
                   </ul>-->
               </div>
               <div class="table-scroll">

                   <table class="table">
                       <thead class="table-head">
                       <tr>
                           <th scope="col">Amount From (Annual)</th>
                           <th scope="col">Amount To (Annual)</th>
                           <th scope="col">Fixed Tax</th>
                           <th scope="col">Tax%</th>
                           <th scope="col">Tax% on Exceeding Amount</th>
                           <th scope="col">Action</th>
                       </tr>
                       </thead>
                       <tbody>
                       <tr v-if="taxSlabs.length>0" v-for="slab in taxSlabs">
                           <td>{{ currencyFormatter2(slab.amount_from) }}</td>
                           <td>{{currencyFormatter2(slab.amount_to)}}</td>
                           <td>{{currencyFormatter2(slab.fixed_value)}}</td>
                           <td>{{slab.exceeding}}%</td>
                           <td>{{slab.exceeding_amount}}</td>
                           <td><button class="border-0 bg-white" data-toggle="modal" data-target=".edit-modal-show"><i @click="editSlabFun(slab.id)" class="fas fa-edit cursor-pointer" ></i></button>
                               <button class="border-0 bg-white" @click="deleteSlabFun(slab.id)"><i class="ico ico-delete text-danger"></i></button>
                           </td>
                       </tr>
                       <tr v-for="(row,index) in rowsAdd">
                           <td class="w-17"><input type="number" class="form-control " placeholder="Amount From (Annual)" v-model="addNewRowSaveWithSlabInfo.amount_from"></td>
                           <td class="w-17"><input type="number" class="form-control " placeholder="Amount To (Annual)" v-model="addNewRowSaveWithSlabInfo.amount_to"></td>
                           <td class="w-17"><input type="number" class="form-control " placeholder="Fixed Tax " v-model="addNewRowSaveWithSlabInfo.fixed_value"></td>
                           <td class="w-17">
                               <div class="d-flex align-items-center percentage">
                                   <input type="number" class="form-control m-auto " placeholder="Tax" v-model="addNewRowSaveWithSlabInfo.exceeding">
                                   <span class="percent-icon">%</span>
                               </div>
                           </td>
                           <td >
                               <div class="d-flex align-items-center">
                                   <input type="checkbox"  v-model="addNewRowSaveWithSlabInfo.is_exceeding_amount" > <input type="number" class="form-control ml-10 mr-20 " v-model="addNewRowSaveWithSlabInfo.exceeding_amount" placeholder="Tax% on Exceeding Amount">
                                   <span ><a @click="saveRowUpdate"><i class="fas fa-save" style="cursor: pointer;" title="Save slab click here"></i></a></span> | <span v-if="index>0"><a @click="removeRowUpdate(index)">  <i class="ico ico-delete text-danger" title="Delete slab click here" style="cursor: pointer;"></i></a></span>
                               </div>
                           </td>
                       </tr>

                       </tbody>
                   </table>
                 <table>
                   <tr v-if="taxSlabs.length>0">
<!--                    <input class="form-control col-1 " type="text" v-model="selectSlabRelaxation"> <button  class="btn col-2">Update</button>-->
                     <br>
                     <div class="input_colorpicker">
                       Medical Relaxation % <input class="jobtype-value" name="name" v-model="selectSlabRelaxation" type="text">
                       <button type="button" @click="UpdateRelaxation"  class="">Update</button>
                     </div>
                   </tr>
                 </table>
                   <button class="btn btn-outline-primary float-right p-10 m-10" v-if="taxSlabs.length>0" @click="addNewRowEditModal">Add row</button>
               </div>
           </div>
       </div>

       <!--modal-->
       <div class="modal fade bd-example-modal-lg slab-info-model" id="add-slab" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
           <div class="modal-dialog modal-xl" style="max-width: 1644px;">
               <div class="modal-content">
                   <header class="model-heading">
                       <h1>Slab Information</h1>
                   </header>
                 <div class="row">
                   <div class="col-md-4 col-sm-6">
                     <div class="form-group">
                       <label >Slab Name</label>
                       <input type="text" v-model="slabForm.name" class="form-control " placeholder="Enter Slab Name">
                     </div>
                   </div>
                   <div class="col-md-4 col-sm-6">
                     <div class="form-group">
                       <label >Medical Relaxation%</label>
                       <input type="text" v-model="slabForm.relaxation" class="form-control " placeholder="Enter Relaxation %">
                     </div>
                   </div>
                 </div>
                   <div class="table-scroll">
                       <table class="table">
                           <thead class="table-head">
                           <tr>
                               <th scope="col">Amount From (Annual)</th>
                               <th scope="col">Amount To (Annual)</th>
                               <th scope="col">Fixed Tax</th>
                               <th scope="col">Tax%</th>
                               <th scope="col">Tax% on Exceeding Amount</th>
                           </tr>
                           </thead>
                           <tbody>

                           <tr v-for="(row,index) in rows">
                               <td><input type="number" class="form-control " placeholder="Amount From (Annual)" v-model="slabForm.amount_from[index]"></td>
                               <td><input type="number" class="form-control " placeholder="Amount To (Annual)" v-model="slabForm.amount_to[index]"></td>
                               <td><input type="number" class="form-control " placeholder="Fixed Tax " v-model="slabForm.fixed_value[index]"></td>
                               <td>
                                   <div class="d-flex align-items-center percentage">
                                    <input type="number" class="form-control m-auto " placeholder="Tax" v-model="slabForm.exceeding[index]">
                                        <span class="percent-icon">%</span>
                                   </div>
                               </td>
                               <td>
                                   <div class="d-flex align-items-center">
                                       <input type="checkbox"  v-model="slabForm.is_exceeding_amount[index]" > <input type="number" class="form-control m-auto " v-model="slabForm.exceeding_amount[index]" placeholder="Tax% on Exceeding Amount">
                                       <span v-if="index>0"><a @click="removeRow(index)"><i class="ico ico-delete text-danger"></i></a></span>
                                   </div>
                               </td>
                           </tr>
                           </tbody>
                           <button class="btn btn-outline-primary float-right p-10 m-10" @click="addRow">Add row</button>
                       </table>
                   </div>

                   <div class="bottom-btn">
                       <a href="#" class="btn btn-white btn-sm" id="closeModal"  data-dismiss="modal">CANCEL</a>
                       <a href="#" class="btn btn-primary btn-sm" data-dismiss="modal" @click="submitSlab" >Save</a>
                   </div>
               </div>
           </div>
       </div>
       <!--edit slab info group-->
       <div class="modal fade slab-info-model" id="edit-slab-group"  v-bind:class="{ 'show': editSlabInfoGroupModal }" style="background: #787a7a" >
           <div class="modal-dialog modal-xl" style="max-width: 1644px;">
               <div class="modal-content">
                   <header class="model-heading">
                       <h1>Update Slab Information</h1>
                   </header>
                   <div class="form-group col-md-12 col-sm-12">
                       <label >Update Slab Name</label>
                       <input type="text"  v-model="editSlabGroupForm.name" class="form-control " placeholder="Enter Slab Name">
                   </div>
        <!--           <div class="table-scroll">
                       <table class="table">
                           <thead class="table-head">
                           <tr>
                               <th scope="col">Amount From (Annual)</th>
                               <th scope="col">Amount To (Annual)</th>
                               <th scope="col">Fixed Tax</th>
                               <th scope="col">Tax %</th>
                               <th scope="col">Tax % on Exceeding Amount</th>
                           </tr>
                           </thead>
                           <tbody>

                           <tr v-for="(rowSlab,index) in editTaxSlabs">
                               <td><input type="text" class="form-control " placeholder="Amount From (Annual)"  v-model="rowSlab.amount_from"></td>
                               <td><input type="text" class="form-control " placeholder="Amount To (Annual)" v-model="rowSlab.amount_to"></td>
                               <td><input type="text" class="form-control " placeholder="Fixed Tax " v-model="rowSlab.fixed_value"></td>
                               <td>
                                   <div class="d-flex align-items-center percentage">
                                       <input type="text" class="form-control m-auto " placeholder="Tax%" v-model="rowSlab.exceeding">
                                       <span class="percent-icon">%</span>
                                   </div>
                               </td>
                               <td>
                                   <div class="d-flex align-items-center">
                                       <input type="checkbox"  v-model="rowSlab.is_exceeding_amount" > <input type="text" class="form-control m-auto " v-model="rowSlab.exceeding_amount" placeholder="Tax% on Exceeding Amount">
                                       <span v-if="index>0"><a @click="removeRow(index)"><i class="ico ico-delete text-danger"></i></a></span>
                                   </div>
                               </td>
                           </tr>
                           </tbody>
                           <button class="btn btn-outline-primary float-right p-10 m-10" @click="addNewRowEditModal">Add row</button>
                       </table>
                   </div>-->

                   <div class="bottom-btn">
                       <a href="#" class="btn btn-white btn-sm"@click="cancelUpdateBtnFun">CANCEL</a>
                       <a href="#" class="btn btn-primary btn-sm" @click="updateSlabInfoGroupSlab" data-dismiss="modal">Save</a>
                   </div>
               </div>
           </div>
       </div>
       <!--edit modal-->
       <div class="modal fade slab-info-model edit-modal-show" tabindex="-1" role="dialog"  aria-hidden="true" >
           <div class="modal-dialog modal-xl">
               <div class="modal-content">
                   <header class="model-heading">
                       <h1>Update Slab</h1>
                       <hr>
                   </header>
                   <div class="row">
                     <!--  <div class="form-group col-md-12 col-sm-12">
                           <label >Slab Name</label>
                           <input type="text" class="form-control " v-model="editSlabForm.name"  placeholder="Enter Slab Name">

                       </div>-->
                       <div class="form-group col-md-6 col-sm-6">
                           <label >Amount From (Annual)</label>
                           <input type="number" class="form-control " v-model="editSlabForm.amount_from"  placeholder="Amount From (Annual)">

                       </div>
                       <div class="form-group col-md-6 col-sm-6">
                           <label >Amount To (Annual)</label>
                           <input type="number" class="form-control " v-model="editSlabForm.amount_to"  placeholder="Amount To (Annual)">

                       </div>
                       <div class="form-group col-md-6 col-sm-6">
                           <label >Fixed Value</label>
                           <input type="number" class="form-control " v-model="editSlabForm.fixed_value"  placeholder="Fixed Value">

                       </div>
                       <div class="form-group col-md-6 col-sm-6">
                           <label >Exceeding % (From)</label>
                           <input type="number" class="form-control " v-model="editSlabForm.exceeding"  placeholder="Exceeding % (From)">
                       </div>
                       <div class="form-group col-md-6 col-sm-6">
                           <label >Is Exceeding Amount</label>
                           <input type="checkbox" v-model="editSlabForm.is_exceeding_amount"  >
                           <input type="number" class="form-control " v-if="editSlabForm.is_exceeding_amount==1" v-model="editSlabForm.exceeding_amount"  placeholder="Exceeding Amount">
                       </div>

                   </div>
                   <div class="bottom-btn mt-15">

                       <a href="#" class="btn btn-white btn-sm"  data-dismiss="modal">CANCEL</a>
                       <button type="button" @click="submitSlabUpdate(editSlabForm.id)" class="btn btn-primary btn-sm" data-dismiss="modal" >Update</button>
                   </div>

               </div>
           </div>
       </div>
   </div>
</template>
<script>
    import Vue from 'vue'
    import moment from 'moment'
    import router from '../../router/router'
    import DatePicker from 'vue2-datepicker'
    import Swal from "sweetalert2";
    export default {
        components: {
            DatePicker
        },
        data() {
            return {
                editSlabInfoGroupModal:false,
                isExceedingAmount:true,
                editSlabForm:{},
                addNewRowSaveWithSlabInfo:{},
                taxSlabInfo:[],
                taxSlabs:[],
                editTaxSlabs:[],
                editSlabGroupForm:[],

                selectSlab:'',
              selectSlabRelaxation:'',
                rowsAdd: [

                ],
                rows: [
                    {amount_from: "",amount_to: "",fixed_value: "",exceeding: "",is_exceeding_amount: "",exceeding_amount: ""}
                ],
                company_id: this.$store.getters.getSelectedCompany.id,
                slabForm:{

                    name:'',
                    relaxation:'',
                    amount_from:[],
                    amount_to:[],
                    fixed_value:[],
                    exceeding:[],
                    is_exceeding_amount:[],
                    exceeding_amount:[],
                },
                rowSlab:{
                    company_id:this.$store.getters.getSelectedCompany.id,
                    name:'',
                    amount_from:[],
                    amount_to:[],
                    fixed_value:[],
                    exceeding:[],
                    is_exceeding_amount:[],
                    exceeding_amount:[],
                }
            }
        },
        serverPrefetch() {
        },
        created() {
            this.getAllTaxSlabInfo();
        },
        mounted() {
        },
        watch:{

        },
        methods: {
          UpdateRelaxation(){
            this.$axios.post(this.$TaxSlabInfo+'/update', {id:this.selectSlab,relaxation:this.selectSlabRelaxation},
              {headers: this.getAuthHeader()})
              .then((res) => {
                if (res.status == 200) {
                  $root.$toast.success(res.data.message);
                }
              })
              .catch((error) => {
              }).finally(() => {
            });
          },
            cancelUpdateBtnFun(){
                this.editSlabInfoGroupModal=false;
            },
            //---------- edit slab info
            editSlabInfo(){
                this.editSlabInfoGroupModal=true;
                let params = {
                    company_id: this.company_id,
                    tax_slab_info_id: this.selectSlab,
                };
                this.$axios.get(this.$TaxSlabsByTaxSlabGroup, {
                    params:params,
                    headers: this.getAuthHeader()
                }).then(response => {
                    this.editSlabGroupForm = response.data.result || []
                    this.editTaxSlabs = this.editSlabGroupForm.slabs
                })
                    .catch(error => {
                        console.log(error);
                    })
            },
            //---------- changeSlabFunction
            changeSlabFunction(event){
            this.selectSlabRelaxation='';
                this.selectSlab=event.target.value;

                this.getAll()
            },

            //---------- add row
            addRow: function(){
                this.rows.push({amount_from: "",amount_to: "",fixed_value: "",exceeding: "",is_exceeding_amount: "",exceeding_amount: ""});
            },  //---------- add row
            addNewRowEditModal: function(){
                this.rowsAdd.push({amount_from: "",amount_to: "",fixed_value: "",exceeding: "",is_exceeding_amount: "",exceeding_amount: ""});
            },

            //--------- remove row
            removeRow: function(row){

                this.rows.splice(row,1);
            },
            //--------- remove row
            removeRowUpdate: function(row){
                this.rowsAdd.splice(row,1);
            },

            //---------- is exceeding amount checkbox click
            isExceedingAmountFun(){
                this.isExceedingAmount=this.slabForm.is_exceeding_amount
            },


            saveRowUpdate(){
                this.addNewRowSaveWithSlabInfo.tax_slab_info_id=this.selectSlab;
                this.addNewRowSaveWithSlabInfo.company_id=this.company_id;
                this.addNewRowSaveWithSlabInfo.multiData='';
                this.storeSlab(this.addNewRowSaveWithSlabInfo);
                this.addNewRowSaveWithSlabInfo={};
                 // this.$router.go(0);
            },
            submitSlab(){
                this.slabForm.tax_slab_info_id='';
                this.slabForm.company_id=this.company_id;
                this.slabForm.multiData='1';
                this.storeSlab(this.slabForm);
                // this.$router.go(0);
               /* setTimeout(()=>{
                    this.$router.go(0);
                },1000);*/


            },
            //------- store slab----------
            storeSlab(data){

                this.$axios.post(this.$TaxSlabs, data,
                    {headers: this.getAuthHeader()})
                    .then((res) => {
                        if (res.status == 200) {
                            this.getAllTaxSlabInfo();
                            $root.$toast.success(res.data.message);
                          $('#add-slab').modal('hide');
                        }
                    })
                    .catch((error) => {
                        // error.response.status Check status code
                    }).finally(() => {
                });
            },
           //-------- edit slab----------
            editSlabFun(id){

                this.$axios.get(this.$TaxSlabs+'/'+id+'/edit', {
                    headers: this.getAuthHeader()
                }).then(response => {
                    this.editSlabForm = response.data.result || []
                })
                    .catch(error => {
                        console.log(error);
                    })
            },
          deleteSlabFun(id){
            new Swal({
              title: "Delete tax slab?",
              icon: "warning",
              text: "Are you sure? You won't be able to revert this!",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Yes, Delete it!"
            }).then((result) => {
              if (result.value) {
                this.$axios.delete(this.$TaxSlabs + '/' + id, {
                  headers: this.getAuthHeader()
                }).then(response => {
                  this.getAll();
                })
                  .catch(error => {
                    console.log(error);
                  });
              }
            });
          },
            submitSlabUpdate(id){
                this.editSlabForm.company_id=this.company_id;
                this.$axios.put(this.$TaxSlabs+'/'+id, this.editSlabForm,
                    {headers: this.getAuthHeader()})
                    .then((res) => {
                        if (res.status == 200) {
                            $root.$toast.success(res.data.message);
                            this.getAllTaxSlabInfo();
                            this.$router.go(0);
                        }
                    })
                    .catch((error) => {
                    }).finally(() => {
                });
            },
            updateSlabInfoGroupSlab(id){
                this.rowSlab.company_id=this.company_id;

            },


           //--------- Tax slab info
            getAllTaxSlabInfo(){
                let params = {
                    company_id: this.company_id,
                };
                this.$axios.get(this.$TaxSlabInfo, {
                    params: params,
                    headers: this.getAuthHeader()
                }).then(response => {
                    if(response.data.result.length>0){
                        this.taxSlabInfo = response.data.result || []
                      this.taxSlabInfo.forEach((sc,key) => {
                            if(sc.is_active==1){
                                this.selectSlab=sc.id;
                                this.selectSlabRelaxation=sc.relaxation;
                            }
                        });
                        this.getAll();
                    }

                })
                    .catch(error => {
                        console.log(error);
                    })
            },

           //-------- get all slabs------
            getAll(){
                let params = {
                    tax_slab_info_id: this.selectSlab,
                    company_id: this.company_id,
                    from_date: this.from_date,
                    to_date: this.to_date,
                };
                this.$axios.get(this.$TaxSlabs, {
                        params: params,
                        headers: this.getAuthHeader()
                    }).then(response => {
                        this.taxSlabs = response.data.result || []
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            //-------------- date filter -------------------
            onChangeDateFun(event){
                this.from_date = moment(event[0]).format('YYYY-MM-DD');
                this.to_date = moment(event[1]).format('YYYY-MM-DD');
            },
            filterFunction(){
                this.getAll();
            },
            currencyFormatter2(value){
     return this.currencyFormatter(value);
    },
        },

    }
</script>


<style>
    .percentage{
        position: relative;
    }

    .percentage .form-control{
        padding-right: 32px;
    }

    .percentage .percent-icon{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 50px;
    }
    .table-scroll .table-head{
        text-transform: capitalize !important;
    }
    .w-17{
        width: 17%;
    }

</style>


